import React from "react";
import _ from "lodash";
import ModalFooter from "components/common/ModalFooter";
import ModalWrapper from "components/common/ModalWrapper";

import { AppConfiguratorAPI } from "apis";
import { MESSAGE } from "constants/Message";
import { inputClass } from "helpers/StyleClass";

class CreateAppConfiguratorModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isSaving: false,

      msg: [],
      editName: "",
    };

    this.handleConfirm = this.handleConfirm.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  async handleConfirm() {
    const { apps } = this.props;
    const { editName } = this.state;

    if (_.isEmpty(editName)) {
      this.setState({ msg: ["App name is required", MESSAGE.ERROR] });
      return;
    }

    if (apps.some((app) => app.name === editName)) {
      this.setState({ msg: ["App name already exists", MESSAGE.ERROR] });
      return;
    }

    this.setState({ isSaving: true, msg: [] });

    const { op } = await AppConfiguratorAPI.createApp({
      appName: editName,
      status: 1,
    });

    if (op === "ok") {
      this.setState({
        msg: ["App created successfully", MESSAGE.SUCCESS],
      });
    } else {
      this.setState({
        msg: [`Failed to create app ${op}`, MESSAGE.ERROR],
      });
    }

    this.setState({ isSaving: false });
  }

  handleCancel() {
    this.props.onCancel();
  }

  handleClose() {
    const { editName } = this.state;
    this.props.onClose(editName);
  }

  render() {
    const { isSaving, msg, editName } = this.state;

    return (
      <ModalWrapper isOpen={true} title="Create App" width="700px">
        <label className="font-semibold text-gray-800">App Name</label>
        <div className="mb-4 w-1/2">
          <input
            className={inputClass}
            placeholder="Enter app name"
            value={editName}
            onChange={(e) => this.setState({ editName: e.target.value })}
          />
        </div>
        <ModalFooter
          msg={msg}
          isLoading={isSaving}
          confirmText="Create"
          onClose={this.handleClose}
          onCancel={this.handleCancel}
          onConfirm={this.handleConfirm} // Placeholder for actual create function
        />
      </ModalWrapper>
    );
  }
}

export default CreateAppConfiguratorModal;
